import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

const styles = css`
  ${({ autoCols, overview }) =>
    !autoCols &&
    !overview &&
    css`
      grid: ${({ grid }) => grid};
    `}
  grid-template: ${({ template }) => template};

  ${({ placeItems }) =>
    placeItems !== undefined &&
    css`
      place-items: ${placeItems};
    `}

  ${({ placeContent }) =>
    placeContent !== undefined &&
    css`
      place-content: ${placeContent};
    `}

  ${({ gridArea }) =>
    gridArea !== undefined &&
    css`
      ${breakpoint("tablet")`
      grid-area: ${gridArea};
    `}
    `}
`

export const StyledGrid = styled.div`
  display: grid;
  gap: ${({ gap }) => gap};

  ${({ simpleForm }) =>
    !!simpleForm &&
    css`
      gap: 16px;
    `}

  ${breakpoint("tablet")`
    ${styles}
  `}

  ${({ mobile }) => !!mobile && styles}
  ${({ autoCols }) =>
    !!autoCols &&
    css`
      grid-auto-flow: column;
    `}

    ${({ fill }) =>
    !!fill &&
    css`
      flex: 1;
    `}

    ${({ overview, videoGrid }) =>
    !!overview &&
    css`
      display: grid;
      grid-template-columns: ${videoGrid ? "1fr" : "repeat(2, 1fr)"} !important;
      gap: 24px;
      align-self: stretch;
    `}
`
